import React from 'react';
import { Cat } from 'lucide-react';

const LoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center p-8 space-y-6">
        <div className="animate-[bounce_2s_infinite]">
          <Cat className="w-16 h-16 text-primary" />
        </div>
      <div className="text-center space-y-3">
        <div className="text-lg font-medium text-primary">
          Hold on, human friend! Kitty is getting ready!
        </div>
        <div className="text-sm text-muted-foreground flex items-center justify-center space-x-2">
        </div>
      </div>
      <div className="w-48 h-1.5 bg-muted rounded-full overflow-hidden">
        <div 
          className="h-full bg-primary rounded-full origin-left animate-[progress_2s_infinite]"
          style={{ width: '100%' }}
        />
      </div>
      <style>
        {`
          @keyframes progress {
            0% {
              transform: scaleX(0);
            }
            100% {
              transform: scaleX(1);
            }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingState;